import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';

import { ModalContainer } from './modal-container.component';
import { ModalDirective } from './modal.directive';
import { ModalService } from './modal.service';

import { OverlayModule } from '@angular/cdk/overlay';
import { ButtonModule } from '../button/button.module';

export { ModalContainer } from './modal-container.component';
export { ModalDirective } from './modal.directive';
export { ModalService } from './modal.service';
export { ModalRef } from './modal-ref';

@NgModule({
  declarations: [
    ModalContainer,
    ModalDirective,
  ],
  exports: [
    ModalContainer,
    ModalDirective,
  ],
  imports: [
    CommonModule,
    OverlayModule,
    ButtonModule,
    IconModule,
  ],
  entryComponents: [
    ModalContainer
  ],
  providers: [
    ModalService,
  ],
})
export class ModalModule { }
